import BaseModel from "~/models/BaseModel";

class SecuritiesAccountModel extends BaseModel {
  isPlatformMt4() {
    return this.platform === "MetaTrader4(EA)";
  }
}

export default SecuritiesAccountModel;
